<template>
  <div>
    <q-dialog v-model="dialog" persistent maximized>
      <q-card>
        <q-card-section class="row items-center q-pa-sm bg-primary text-white">
          <div class="text-h6">Resultados da pesquisa</div>
          <q-space />
          <q-btn icon="close" flat round dense @click="dialog = false" />
        </q-card-section>
        <q-card-section class="q-pa-none no-shadow">
          <div class="col-12">
            <q-linear-progress color="primary" indeterminate v-if="loading" />
            <q-tabs
              v-model="tab"
              class="bg-primary text-white"
            >
              <q-tab name="1" label="Por usuário" />
              <q-tab name="2" label="Geral" />
            </q-tabs>
            <q-separator />
            <q-tab-panels v-model="tab" animated>
              <q-tab-panel name="1">
                <GridRespondedores :idPesquisa="idPesquisa" />
              </q-tab-panel>
              <q-tab-panel name="2">
                <Estatisticas :idPesquisa="idPesquisa" />
              </q-tab-panel>
            </q-tab-panels>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import GridRespondedores from './GridRespondedores'
import Estatisticas from './Estatisticas'

export default {
  props: {
    idPesquisa: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      dialog: false,
      loading: false,
      tab: '1'
    }
  },
  mounted () {

  },
  methods: {
    open () {
      this.tab = '1'
      this.dialog = true
    }
  },
  components: {
    GridRespondedores,
    Estatisticas
  }
}
</script>